/*
 * サブシステム名：
 * 定型コース登録(package版)
 * 表示項目カスタマイズ(antz)
 */
import D2MSTD0460 from '@/views/MST/D2MSTD0460.js'
import filter from '@/rahmen/utils/filters'

export default {
  extends: D2MSTD0460,
  name: 'MstTeikeiCorceEditCustomForAntz',
  data: () => ({
  }),
  computed: {
    // ----------------------------------------------------------------------------------------------------
    // 金額計算
    // ----------------------------------------------------------------------------------------------------
    calcShiharaiKingakuAmount () {
      let yoshaUnchin = this.rec.yoshaUnchin
      let yoshaHiwayPrice = this.rec.yoshaHiwayPrice
      let yoshaUnchinHokaKingaku = this.rec.yoshaUnchinHokaKingaku
      let yoshaUnchinHokaHikazei = this.rec.yoshaUnchinHokaHikazei

      if (yoshaUnchin === undefined || yoshaUnchin === '' || yoshaUnchin === null) { yoshaUnchin = '0' }
      if (yoshaHiwayPrice === undefined || yoshaHiwayPrice === '' || yoshaHiwayPrice === null) { yoshaHiwayPrice = '0' }
      if (yoshaUnchinHokaKingaku === undefined || yoshaUnchinHokaKingaku === '' || yoshaUnchinHokaKingaku === null) { yoshaUnchinHokaKingaku = '0' }
      if (yoshaUnchinHokaHikazei === undefined || yoshaUnchinHokaHikazei === '' || yoshaUnchinHokaHikazei === null) { yoshaUnchinHokaHikazei = '0' }

      let amount = 0

      amount = parseInt(yoshaUnchin, 10) +
                parseInt(yoshaHiwayPrice, 10) +
                parseInt(yoshaUnchinHokaKingaku, 10) +
                parseInt(yoshaUnchinHokaHikazei, 10)

      return amount
    }
  },
  methods: {
    calcTaikiJikanKingaku: function () {
      let taikiJikan = this.rec.taikiJikan
      let taikiJikanTanka = this.rec.taikiJikanTanka

      if (taikiJikan === undefined || taikiJikan === '' || taikiJikan === null) { taikiJikan = '00:00' }
      if (taikiJikanTanka === undefined || taikiJikanTanka === '' || taikiJikanTanka === null) { taikiJikanTanka = 0 }

      taikiJikan = filter.timeToMinFormatter(taikiJikan)

      const taikiJikanKingaku = this.calcFraction((taikiJikan / 60) * taikiJikanTanka)
      this.$set(this.rec, 'taikiJikanKingaku', taikiJikanKingaku)
      this.calcUriageKingakuAmount()
    },
    calcUriageKingakuAmount: function () {
      let amount = 0
      // const hasuKeisanKbn = this.recTokuisakiInfo.unchinHasuKeisanKbn ? this.recTokuisakiInfo.unchinHasuKeisanKbn : '02'
      amount += parseInt(this.calcUnchin, 10)
      if (this.rec.hiwayPrice) { amount += parseFloat(this.rec.hiwayPrice, 10) }
      if (this.rec.unchinHokaKingaku) { amount += parseFloat(this.rec.unchinHokaKingaku, 10) }
      if (this.rec.unchinHokaHikazei) { amount += parseFloat(this.rec.unchinHokaHikazei, 10) }
      if (this.rec.taikiJikanKingaku) { amount += parseFloat(this.rec.taikiJikanKingaku, 10) }
      if (this.rec.jikanWarimashiKingaku) { amount += parseFloat(this.rec.jikanWarimashiKingaku, 10) }
      if (this.rec.kyoriWarimashiKingaku) { amount += parseFloat(this.rec.kyoriWarimashiKingaku, 10) }
      if (this.rec.warimashiSonotaKingaku) { amount += parseFloat(this.rec.warimashiSonotaKingaku, 10) }

      this.$set(this.rec, 'uriageKingaku', amount)
    },
    registerPromise: function () {
      this.convertToDBType()
      const f = this.HttpClient.post('/api/v1/VwCD2mstd0460/CreateSeikyuUriageSeparate', this.rec)
      return f
    }
  }
}
